<template>
    <div id="wn-fixed" class="wn-fixed">
        <ul class="float-contact">
            <li class="item" @mouseenter="showWx = true" @mouseleave="showWx = false">
                <div class="floatbtn">
                    <div class="icons"><span class="iconfont icon-weixin"></span></div>
                    <div class="fonts">{{ $t('contactus.wechat') }}</div>
                </div>
                <div class="popup" v-show="showWx">
                    <img src="@/assets/images/code.jpg">
                </div>
            </li>
            <li class="item" @mouseenter="showTel = true" @mouseleave="showTel = false">
                <div class="floatbtn">
                    <div class="icons"><span class="iconfont icon-dianhua"></span></div>
                    <div class="fonts">{{ $t('contactus.phone') }}</div>
                </div>
                <div class="popup" v-show="showTel">
                    <div class="tel"><p>{{ $t('contactus.phone') }}</p><p class="p2">{{ $t('contactus.tel') }}</p></div>
                </div>
            </li>
            <!-- 🔥 新增：返回顶部按钮 -->
            <li class="item" @click="backToTop">
                <div class="floatbtn">
                    <div class="icons"><span class="iconfont icon-fanhuidingbu"></span></div>
                    <div class="fonts">{{ $t('common.backTop') }}</div>
                </div>
            </li>
        </ul>
    </div>
</template>

<script setup>
    import { ref } from 'vue'
    const showWx = ref(false)
    const showTel = ref(false)

    // 🔥 新增：返回顶部方法（平滑滚动到顶部）
    const backToTop = () => {
        // behavior: 'smooth' 实现平滑滚动，不加则是瞬间跳转
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth'
        })
    }
</script>

<style scoped lang="scss">
    .wn-fixed {
        position: fixed;
        right: 10px;
        top: 60%;
        display: flex;
        flex-direction: column;
        background: #ffffff;
        border-radius: 6px;
        box-shadow: 0 0 6px rgba(19, 71, 214, 0.15);
        z-index: 9999;
    }
    ul {
        display: inline-block;
        width: 100%;
    }
    li {
        position: relative;
        width: 70px;
        height: 70px;
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
        cursor: pointer;
    }
    .floatbtn {
        display: inline-block;
        width: 100%;
        padding:0.5rem 0;
    }
    .popup {
        position: absolute;
        right: 100%;
        top: 50%;
        transform: translateY(-50%);
        margin-right: 10px;
        padding: 10px;
        border-radius: 8px;
        background-color: #ffffff;
        box-shadow: 0 2px 10px rgba(0,0,0,0.1);
    }
    .popup img {
        width: 190px;
        height: 190px;
        display: block;
    }
    p {
        margin:0.2rem 0;
        text-transform: uppercase;
    }
    .p2 {
        color: var(--fontred);
        font-size: 1.2rem;
        font-family: 'Arial', sans-serif;
    }
    .tel {
        font-size: 16px;
        padding: 10px 15px;
        white-space: nowrap;
    }
    .icons {
        display: inline-block;
        width: 100%;
        text-align: center;
    }
    .iconfont {
        color: var(--main);
        font-size: 1.8rem;
        transition:all 0.6s;
    }
    .fonts {
        color: #555;
        font-size: 12px;
        transition:all 0.6s;
    }
    // 🔥 调整边框：前两个li加底边框，第三个不加
    li:nth-child(1), li:nth-child(2) {
        border-bottom: 1px solid rgba(0,0,0,0.07);
    }
    li:hover {
        .iconfont {
            color: var(--fontred);
        }
        .fonts {
            color:var(--fontred);
        }
    }
</style>